import {profileTenantGuard} from './core/guards/profile-tenant.guard';
import { Routes } from '@angular/router';
import { authGuard, flowContextGuard } from './core/guards';

export const routes: Routes = [
  {path:'my-tickets',canActivate:[authGuard],loadComponent:()=>import('./features/events/my-event-tickets.component').then(m=>m.MyEventTicketsComponent)},
  {path:'events/:id',canActivate:[flowContextGuard],data:{flowContextOptional:true},loadComponent:()=>import('./features/events/event-registration.component').then(m=>m.EventRegistrationComponent)},
  {path:'unsubscribe',loadComponent:()=>import('./features/profile/unsubscribe.component').then(m=>m.UnsubscribeComponent)},
  // Landing page pública (desde QR)
  {
    path: 'promotion/:id',
    canActivate: [flowContextGuard],
    loadComponent: () => import('./features/promotions/promotion-landing/promotion-landing.component').then(m => m.PromotionLandingComponent)
  },

  // Autenticación
  {
    path: 'login',
    canActivate: [flowContextGuard],
    data: { flowContextOptional: true },
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    canActivate: [flowContextGuard],
    data: { flowContextOptional: true },
    loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'promotion/:id/complete-profile',
    canActivate: [flowContextGuard, authGuard],
    loadComponent: () => import('./features/promotions/sweepstakes-profile-step/sweepstakes-profile-step.component').then(m => m.SweepstakesProfileStepComponent)
  },
  {
    path: 'flow-error',
    loadComponent: () => import('./features/flow/flow-error/flow-error.component').then(m => m.FlowErrorComponent)
  },

  {path:'saved-promotions',canActivate:[authGuard],loadComponent:()=>import('./features/saved/saved-promotions.component').then(m=>m.SavedPromotionsComponent)},
  {path:'saved/:id',canActivate:[authGuard],data:{savedPromotion:true},loadComponent:()=>import('./features/promotions/promotion-landing/promotion-landing.component').then(m=>m.PromotionLandingComponent)},
  // Áreas protegidas (requieren login)
  {
    path: 'promotions',
    loadComponent: () => import('./features/promotions/promotion-landing/promotion-landing.component').then(m => m.PromotionLandingComponent)
  },
  {
    path: 'my-coupons',
    loadComponent: () => import('./features/coupons/my-coupons/my-coupons.component').then(m => m.MyCouponsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'coupons/code/:code',
    loadComponent: () => import('./features/coupons/coupon-detail/coupon-detail.component').then(m => m.CouponDetailComponent),
    canActivate: [authGuard]
  },
  {
    path: 'coupons/:id',
    loadComponent: () => import('./features/coupons/coupon-detail/coupon-detail.component').then(m => m.CouponDetailComponent),
    canActivate: [authGuard]
  },
  {
    path: 'redeem/scan',
    loadComponent: () => import('./features/redemption/scan-qr/scan-qr.component').then(m => m.ScanQrComponent),
    canActivate: [authGuard]
  },
  {
    path: 'history',
    redirectTo: 'my-coupons',
    pathMatch: 'full'
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/my-profile/my-profile.component').then(m => m.MyProfileComponent),
    canActivate: [authGuard,profileTenantGuard]
  },

  // Redirecciones
  { path: '', redirectTo: '/promotions', pathMatch: 'full' },
  { path: '**', redirectTo: '/promotions' }
];
